import { connect } from 'react-redux';

import { openSubscribeDialog } from '../../../../app/components/common/SubscribeMailingListDialog/action/SubscribeMailingListActions';
import Footer from '../components/Footer';

const mapDispatchToProps = dispatch => {
  return {
    onSubscribeToMailingListClicked: () => dispatch(openSubscribeDialog()),
  };
};

export default connect(
  null,
  mapDispatchToProps
)(Footer);
